//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SubscribeHero2026SoftwareBadges',
  components: {
    ProductIcon: () => import('@motionelements/core/src/components/product/ProductIcon.vue'),
  },
  data() {
    return {
      pills: [
        { productType: 'ae', square: false },
        { productType: 'pr', square: false },
        { productType: 'animation' },
        { productType: 'resolve' },
        { productType: 'video' },
        { productType: 'music' },
        { productType: 'sfx' },
        { productType: 'image' },
        { productType: '3d' },
      ],
    };
  },
};
